const config = {
    host: (process.env.NODE_ENV === 'production') ? 'https://silo.dvgeo.app' : 'http://192.168.100.106:3074',
    homePage: (process.env.NODE_ENV === 'production') ? 'https://silo.dvgeo.app' : 'http://192.168.100.106:3074',
    api: 'api/',
    apiSocket: 'silo::1.2',
    nameDir: 'silo',
    package: 'ec.silo.web',
    version: '1.0.2',
    googleAPIKey: 'AIzaSyCnj1bm_FUTqMD4F-REccJBAzURlgsVkZ4',
    appName: 'SILO',
    provider: '',
    colorPrimary: '#000000',
    colorDark: '#000000',
    colorAccent: '#ccc',
    colorTextPrimary: '#fff',
    colorTextDark: '#000',
    playStorePassengerId: 'ec.silo.passenger',
    playStoreDriverId: 'ec.silo.driver',
    appStorePassengerId: '6755793448',
    appStoreDriverId: '6755794972',
};
export default config;
